import Constants from '../Constants';
import { ApplicationState, store } from '../store';
import Category from './Category';

export type CourseViewType =
    | 'listCoursesHavingAContentStudentView'
    | 'listMyCourseStudentView'
    | 'listEssentialStudentView'
    | 'listPublishedUserContentsStudentView';

export type ViewType =
    | 'listEssentialStudentView'
    | 'listLastPublishedStudentView'
    | 'listMostAccessedStudentView'
    | 'listInProgressStudentView'
    | 'listCompletedStudentView'
    | 'listTopRatedStudentView'
    | 'listFavoriteStudentView'
    | 'listOfCategories'
    | 'listLikeYouStudentView'
    | 'listForYouStudentView'
    | 'listSearchResultStudentView'
    | 'listMyCourseStudentView'
    | 'listSuggestedStudentView'
    | 'listTrainingsEnrolledStudentView';

const viewTypeList: ViewType[] = [
    'listEssentialStudentView',
    'listForYouStudentView',
    'listInProgressStudentView',
    'listLikeYouStudentView',
    'listLastPublishedStudentView',
    'listOfCategories',
    'listMostAccessedStudentView',
    'listTopRatedStudentView',
];

const getViewTypeData = (type: ViewType) => {
    const {
        appOrganization: {
            data: { isWhiteLabel },
        },
        locale: { data: strings },
    } = store.getState() as ApplicationState;

    if (type.startsWith(Constants.listCategorizedPrefix)) {
        const category: Category = store.getState().categories.data.category;
        return { title: category.name, resource: '' };
    }

    return {
        listLastPublishedStudentView: {
            title: strings.LATEST_PUBLISHED_LISTS,
            resource: Constants.VIEW_TYPE_RESOURCE_NEW_REALEASES,
        },
        listMostAccessedStudentView: {
            title: isWhiteLabel ? strings.MOST_ACCESSED_LISTS_WHITELABEL : strings.MOST_ACCESSED_LISTS,
            resource: Constants.VIEW_TYPE_RESOURCE_TRENDING,
        },
        listInProgressStudentView: {
            title: strings.IN_PROGRESS_LISTS,
            resource: Constants.VIEW_TYPE_RESOURCE_IN_PROGRESS,
        },
        listCompletedStudentView: {
            title: strings.COMPLETED_LISTS,
            resource: Constants.VIEW_TYPE_RESOURCE_COMPLETED,
        },
        listTopRatedStudentView: {
            title: strings.TOP_RATED_LISTS,
            resource: Constants.VIEW_TYPE_RESOURCE_TOP_RATED,
        },
        listFavoriteStudentView: {
            title: strings.FAVORITES_PAGE,
            resource: Constants.VIEW_TYPE_RESOURCE_FAVORITES,
        },
        listOfCategories: {
            title: strings.LIST_OF_CATEGORIES,
            resource: Constants.CATEGORY,
        },
        listForYouStudentView: {
            title: strings.FOR_YOU_LISTS,
            resource: Constants.VIEW_TYPE_RESOURCE_FOR_YOU,
        },
        listLikeYouStudentView: {
            title: strings.LIKE_YOU_LISTS,
            resource: Constants.VIEW_TYPE_RESOURCE_LIKE_YOU,
        },
        listSearchResultStudentView: {
            title: strings.SEARCH_RESULT_LISTS,
            resource: Constants.VIEW_TYPE_RESOURCE_SEARCH_RESULT,
        },
        listSuggestedStudentView: {},
        listMyCourseStudentView: {},
        listEssentialStudentView: {
            title: strings.ESSENTIAL_SECTION.ESSENTIALS,
            resource: Constants.VIEW_TYPE_RESOURCE_ESSENTIALS,
        },
        listTrainingsEnrolledStudentView: {},
    }[type];
};

export { getViewTypeData, viewTypeList };
